import { render, staticRenderFns } from "./JournalismList.vue?vue&type=template&id=7b9d03ea&scoped=true"
import script from "./JournalismList.vue?vue&type=script&lang=js"
export * from "./JournalismList.vue?vue&type=script&lang=js"
import style0 from "./JournalismList.vue?vue&type=style&index=0&id=7b9d03ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9d03ea",
  null
  
)

export default component.exports